export const INPUT_TYPES_WITHOUT_SEARCH_TYPE = [
  'select',
  'date-range',
  'index_entry',
];
